import React from 'react'
import { TableHeadersType } from '../../../../constant/tableHeadersConstants/tableHeadersType';
import { formatDate, formateDateTime } from '../../../../utils/commonFunctions';
import "./jobsTable.scss"
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { deleteIcon, tableEditIcon } from '../../../../assets/images';
import UpdatedByAndUpdatedAt from '../../../commons/CommonUpdatedByAndUpdatedAt';
type AppProps = {
    history:any;
    data: any;
    isEditJobsPresent?:boolean;
    tableHeader: TableHeadersType[];
    handleEditJobsDetails: (id: string) => void;
}
const JobsTableData = ({
    history,
    data,
    tableHeader,
    isEditJobsPresent,
    handleEditJobsDetails
}: AppProps) => {
    const handleEditJobs = (id: string) => {
      handleEditJobsDetails(id)
    }
    const handleDeleteJobs = (id: string) => {
    }
    return (
        <>{data && data?.length > 0 && data?.map((itemData: any) => {

            const jobDetails = `${itemData?.job_id}_${itemData?.job_type}_${itemData?.period_ended}`;
            return <tr key={itemData?._id}>
                {

                    tableHeader?.map((item: TableHeadersType) => {
                        if (item?.value === "target_end_date") {
                            return <td>{itemData?.target_end_date ? itemData?.target_end_date : "--/--"}</td>
                        }
                        else if(item?.value=="job_id"){
                            return <td>{jobDetails}</td>
                        }
                        else if(item?.value==="period_ended"){
                            return <td>{itemData?.period_ended ? itemData?.period_ended : "--/--"}</td>
                        }
                       else if (item?.value === "client") {
                            return <td>{itemData?.client_details? `${itemData?.client_details?.company_name} (${itemData?.client_details?.client_code})` : "--/--"}</td>
                        }
                        else if (item?.value === "updated_by") {
                            return (
                              <td style={{width:'260px'}}>
                                 <UpdatedByAndUpdatedAt
                                  firstName={itemData?.updated_by?.first_name}
                                  lastName={itemData?.updated_by?.last_name}
                                  profilePic={itemData?.updated_by?.profile_pic?.file_url}
                                  updatedAt={formateDateTime(itemData?.updated_at)}
                      />
                                
                              </td>
                            );
                          }
                        else if (item?.value === "job_description") {
                            return <td style={{ width: "200px" }}>{itemData?.job_description?.length > 35 ? <OverlayTrigger
                                placement="bottom"
                                delay={{ show: 250, hide: 250 }}
                                overlay={
                                    <Tooltip id="button-view-filter-invoice">
                                        {itemData?.job_description}
                                    </Tooltip>
                                }
                            >
                                <p>{`${itemData?.job_description?.slice(0, 35)}...`}</p>
                            </OverlayTrigger> : itemData?.job_description ? itemData?.job_description : "--/--"
                            }</td>
                        }
                        if (item?.value === "job_status") {
                            return <td>{itemData?.job_status === "Open" ? <span className='Open'>{itemData?.job_status}</span> : <span className='Close'>{itemData?.job_status}</span>}</td>
                        }
                        return <td>{itemData[item?.value]}</td>
                    })
                }
                <td style={{ width: '50px', textAlign: 'start' }}>
                    <div className='d-flex'>
                      {isEditJobsPresent &&  <span className="d-inline-block pointer"
                        >
                            <div style={{
                                color: '#d43',
                                fontSize: 20,
                                width: '30px',
                            }}>
                                <img onClick={() => handleEditJobs?.(itemData?._id)} src={tableEditIcon} alt='' />
                            </div>
                        </span>}
                        {/* <span className="d-inline-block pointer"
                        >
                            <div style={{
                                color: '#d43',
                                fontSize: 20,
                                width: '30px',
                            }}>
                                <img onClick={() => handleDeleteJobs?.(itemData?._id)} src={deleteIcon} alt='' />
                            </div>
                        </span> */}
                    </div>
                </td>
            </tr>
        })}
        </>
    )
}

export default JobsTableData